import { render, staticRenderFns } from "./node-area.vue?vue&type=template&id=64255a49&scoped=true&"
import script from "./node-area.vue?vue&type=script&lang=js&"
export * from "./node-area.vue?vue&type=script&lang=js&"
import style0 from "./node-area.vue?vue&type=style&index=0&id=64255a49&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64255a49",
  null
  
)

export default component.exports